import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const LibraryDashboard = lazyPage(() => import('@/pages/library/Dashboard'));
const LibraryBooks = lazyPage(() => import('@/pages/library/Books'));
const LibraryCategories = lazyPage(() => import('@/pages/library/Categories'));
const LibraryContributors = lazyPage(() => import('@/pages/library/Contributors'));
const LibraryIssueBooks = lazyPage(() => import('@/pages/library/IssueBooks'));
const LibraryReturnBooks = lazyPage(() => import('@/pages/library/ReturnBooks'));
const LibraryReservations = lazyPage(() => import('@/pages/library/Reservations'));
const LibraryFines = lazyPage(() => import('@/pages/library/Fines'));
const LibraryMembers = lazyPage(() => import('@/pages/library/Members'));
const LibraryInventory = lazyPage(() => import('@/pages/library/Inventory'));
const LibraryReports = lazyPage(() => import('@/pages/library/Reports'));

export const libraryRoutes: AppRoute[] = [
  {
    path: 'library',
    title: 'Library',
    children: [
      { path: '', title: 'Library', component: ModuleMenu },
      { path: 'dashboard', title: 'Dashboard', component: LibraryDashboard },
      { path: 'books', title: 'Books', component: LibraryBooks },
      { path: 'categories', title: 'Categories', component: LibraryCategories },
      { path: 'contributors', title: 'Contributors', component: LibraryContributors },
      { path: 'issue-books', title: 'Issue Books', component: LibraryIssueBooks },
      { path: 'return-books', title: 'Return Books', component: LibraryReturnBooks },
      { path: 'reservations', title: 'Reservations', component: LibraryReservations },
      { path: 'fines', title: 'Fines', component: LibraryFines },
      { path: 'members', title: 'Members', component: LibraryMembers },
      { path: 'inventory', title: 'Inventory', component: LibraryInventory },
      { path: 'reports', title: 'Library Reports', component: LibraryReports },
    ],
  },
];
